export default {
  'delegations.title': 'Manage Delegations',

  'delegations.form.id': 'ID',
  'delegations.form.status': 'Status',
  'delegations.form.type': 'Type',
  'delegations.form.delegationNumber': 'Delegation Number',
  'delegations.form.startDate': 'Start Date',
  'delegations.form.startDateMinLead':
    'Start date and time must be at least {minutes} minutes after the current time.',
  'delegations.form.endDate': 'End Date',
  'delegations.form.endDateAfterStart': 'End date must be after the start date.',
  'delegations.form.approver': 'Approver User',
  'delegations.form.sourceUserHint':
    'The user who will be absent—the person you are creating this delegation for.',
  'delegations.form.reason': 'Reason',
  'delegations.form.delegatePendingTasks': 'Delegate Pending Tasks?',
  'delegations.form.keepSourceUserAsApproval': 'Keep Source User as Approver?',
  'delegations.form.removeDelegatedTasksAtTheEnd': 'Remove Delegated Tasks at End of Delegation?',
  'delegations.form.voidedReason': 'Voided Reason',
  'delegations.form.voidedDate': 'Voided Date',
  'delegations.form.voidedUser': 'Voided By',

  'delegations.delegationType.temporary': 'Temporary',
  'delegations.delegationType.definitive': 'Definitive',

  'delegations.delegationStatus.pending': 'Pending',
  'delegations.delegationStatus.execution': 'In Progress',
  'delegations.delegationStatus.finished': 'Completed',
  'delegations.delegationStatus.voided': 'Cancelled',
  'delegations.delegationStatus.error': 'Error',
  'delegations.delegationStatus.modal.cancel.title': 'Cancellation Reason',
  'delegations.delegatedTasks': 'Delegated Tasks',
};
